import React, { useState } from 'react'
import { apiurl } from '../../path'
import { login_side_img,Adminimg,BankofMaharashtraLogo256 ,VadhvanLogo256} from '../../public/LoginImages/importimages';
const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  
  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
    let Forgettoken=await fetch(apiurl+'/ForgetPassword',
    {method:"POST",
    headers:({'Content-Type': 'Application/json'}),
    body:JSON.stringify({email:email})})
    Forgettoken= await Forgettoken.json()
   if(Forgettoken)
   {
    alert('link has sent to email')
   }else{
    alert('Not valid Email')
   }

    } catch (error) {
      console.error("Error in AdminLogin:", error);
    }
  };
  // return (
  //   <div style={{ display: 'flex', justifyContent: 'space-between', height: '100vh', alignItems: 'center' }}>
  //     <img src={login_side_img} style={{ width: "60vw" }} />
  //     <div style={{textAlign:'center',marginRight:'85px'}}>
  //       <h2 style={{color:'orange'}}>Forgot Password?</h2>
  //       <p style={{fontSize:"12px"}}>Enter your registered email address, and we will help you to
  //         set a new password.</p>
  //       <form onSubmit={handleResetPassword}>
  //         <input
  //           style={{border:"none",borderRadius:"0",borderBottom:"2px solid"}}
  //           type="email"
  //           placeholder="Enter your email"
  //           onChange={(e) => setEmail(e.target.value)}
  //           required
  //           className='form-control'
  //         />
  //         <button type='submit' className="btn btn-primary my-5" style={{width:"40%",border:"1px solid red",borderRadius:"20px",backgroundColor:"#e73d26"}}>Send Reset Link</button>
  //         <div>
  //                   <p style={{color:'orange'}}><a href='/AdminLogin'>Back To Sign In</a></p>
  //                 </div>
  //       </form>
  //     </div>
  //   </div>
  // )
   return (
     
        <div className="admin-login-container">
          <style>{`
   
        .admin-login-container {
          width: 100%;
          min-height: 100vh;
          display: flex;
          background: #e7f3fc;
          overflow: hidden;
        }
   
        .admin-login-image {
          width: 55%;
          height: 100vh;
          position: relative;
          overflow: hidden;
        }
   
        .admin-login-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
   
        .login-image-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 45, 105, 0.72);
        }
   
        .login-side-content {
          position: absolute;
          top: 18%;
          left: 12%;
          width: 75%;
          color: white;
          z-index: 2;
        }
   
        .login-side-content h2 {
          font-size: 22px;
          margin-bottom: 28px;
          color: white;
        }
   
        .security-point {
          display: flex;
          gap: 14px;
          margin-bottom: 20px;
        }
   
        .security-point .arrow {
          font-size: 30px;
          font-weight: bold;
        }
   
        .security-point p {
          margin: 0;
          font-size: 15px;
          line-height: 1.3;
        }
   
        .login-side-footer {
          position: absolute;
          bottom: 3%;
          left: 10%;
          width: 80%;
          text-align: center;
          color: white;
          z-index: 3;
        }
   
        .login-side-footer p {
          font-size: 13px;
          line-height: 1.3;
          margin: 0;
        }
   
        .login-side-footer span {
          color: #ffd000;
        }
   
        .bank-maharashtra-footer-logo {
          width: 125px;
          margin-top: 8px;
        }
   
        .admin-login-form-container {
          width: 45%;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px 50px;
          box-sizing: border-box;
        }
   
        .admin-login-form {
          width: 100%;
          max-width: 400px;
          background: #f5f8fd;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,.22);
        }
   
        .login-header {
          height: 105px;
          position: relative;
          background: #00549b;
          overflow: hidden;
        }
   
        .login-header::after {
          content: "";
          position: absolute;
          left: -5%;
          bottom: -32px;
          width: 110%;
          height: 65px;
          background: #f58220;
          border-radius: 50%;
        }
   
        .login-header::before {
          content: "";
          position: absolute;
          left: -5%;
          bottom: -18px;
          width: 110%;
          height: 42px;
          background: #f5f8fd;
          border-radius: 50%;
          z-index: 2;
        }
   
        .login-logo-section {
          position: relative;
          z-index: 5;
          height: 75px;
          display: flex;
          align-items: center;
          padding: 10px 22px;
        }
   
        .login-logo {
          width: 45px;
          height: 45px;
          object-fit: contain;
          margin-right: 10px;
        }
   
        .login-title {
          color: white;
          font-size: 20px;
          font-weight: 700;
          white-space: nowrap;
        }
   
        .login-title span {
          display: block;
          font-size: 8px;
          font-weight: 400;
        }
   
        .login-content {
          padding: 32px 42px 28px;
        }
   
        .forgot-icon {
          width: 56px;
          height: 56px;
          margin: 5px auto 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e5edf9;
          border-radius: 50%;
          color: #005ba4;
          font-size: 25px;
        }
   
        .login-heading {
          text-align: center;
          margin-bottom: 25px;
        }
   
        .login-heading h2 {
          margin: 0;
          font-size: 25px;
          color: #111;
        }
   
        .login-heading p {
          margin: 5px 0 0;
          color: #999;
          font-size: 12px;
          line-height: 1.4;
        }
   
        .login-field {
          margin-bottom: 25px;
        }
   
        .login-field label {
          display: block;
          margin-bottom: 8px;
          font-size: 15px;
          font-weight: 700;
        }
   
        .input-wrapper {
          position: relative;
          width: 100%;
          height: 47px;
          background: #f8fbff;
          border: 1px solid #c8d9eb;
          border-radius: 9px;
        }
   
        .input-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #8a8a8a;
          z-index: 2;
        }
   
        .login-input {
          position: absolute;
          left: 42px;
          top: 0;
          width: calc(100% - 55px);
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          padding: 0;
          font-size: 13px;
        }
   
        .login-button-container {
          display: flex;
          justify-content: center;
        }
   
        .admin-login-btn {
          width: 100%;
          height: 44px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(to right,#005ba4,#006db1,#0085c5);
          color: white;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
        }
   
        .back-signin {
          text-align: center;
          margin-top: 24px;
        }
   
        .back-signin a {
          color: #0071bd;
          font-size: 14px;
          text-decoration: none;
        }
   
        @media (max-width: 768px) {
          .admin-login-container {
            flex-direction: column;
            overflow-y: auto;
          }
   
          .admin-login-image,
          .admin-login-form-container {
            width: 100%;
          }
   
          .admin-login-image {
            height: 450px;
          }
   
          .admin-login-form-container {
            padding: 25px 15px 40px;
          }
        }
   
      `}</style>
   
      {/* ================= LEFT SIDE ================= */}
      <div className="admin-login-image">
   
       <img
          src={Adminimg}
          className="admin-login-img"
          alt="Login"
        />
   
        {/* BLUE OVERLAY */}
        <div className="login-image-overlay"></div>
   
        {/* LEFT CONTENT */}
        <div className="login-side-content">
   
          <h2>
            LRS प्रोजेक्टच्या सुरक्षित वापरासाठी सूचना
          </h2>
   
          <div className="security-point">
            <span className="arrow">»</span>
   
            <p>
              Cyber Attack, Virus आणि Malware चे धोके कमी करण्यासाठी, LRS च्या
              सर्व्हरवर लॉगिन करताना त्यांच्या System मधून (डेस्कटॉप / लॅपटॉप)
              LRS पोर्टलमध्ये प्रवेश करताना खात्रीत सुरक्षा उपायांची अंमलबजावणी
              करणे बाबत.
            </p>
          </div>
   
          <div className="security-point">
            <span className="arrow">»</span>
   
            <p>
              External storage चा वापर करताना काळजीपूर्वक करणे आवश्यक आहे.
              अनवधानाने त्यात Virus आणि Malware संगणकावर येऊ शकतात त्यामुळे
              डेटा चोरीची शक्यता असते.
            </p>
          </div>
   
          <div className="security-point">
            <span className="arrow">»</span>
   
            <p>
              Licensed अँटी व्हायरस Software चा वापर करा. अँटी व्हायरस
              अँप्लिकेशन योग्यरीत्या Install केले आहे आणि नियमितपणे अपडेट केले
              आहे याची खात्री करा. इंटरनेट Authorized आणि Licensed Software
              चा वापर करा.
            </p>
          </div>
   
        </div>
   
        {/* LEFT FOOTER */}
        <div className="login-side-footer">
   
          <p>
            Contents on this website are owned, updated and managed by the
            <br />
            Liability Register System, Government of Maharashtra. Site is technically designed,
            <br />
            hosted and maintained by Bank of Maharashtra.
            <span> Bank of Maharashtra.</span>
          </p>
   <div><img src={BankofMaharashtraLogo256} style={{ width: "200px",
            height: "45px", marginTop:"25px"}}/></div>
   
         
   
        </div>
   
      </div>
   
   
      {/* ================= RIGHT SIDE ================= */}
      <div className="admin-login-form-container">
   
        <form
          onSubmit={handleResetPassword}
          className="admin-login-form"
        >
   
          {/* HEADER */}
          <div className="login-header">
   
            <div className="login-logo-section">
   
              <img
                             src={VadhvanLogo256}
                             className="sidebar-logo"
                             alt="..."
                             style={{
                               width: "38px",
                               height: "38px",
                               objectFit: "contain",
                             }}
                           />
   
              <div className="login-title">
   
                <div>
                  Liability Register System
                </div>
   
                <span>
                  (Urban Development Department, Government Of Maharashtra)
                </span>
   
              </div>
   
            </div>
   
          </div>
   
   
          {/* FORM CONTENT */}
          <div className="login-content">
   
            {/* KEY ICON */}
            <div className="forgot-icon">
   
              <i className="fa-solid fa-key"></i>
   
            </div>
   
   
            {/* HEADING */}
            <div className="login-heading">
   
              <h2>
                Forgot Password?
              </h2>
   
              <p>
                Enter your registered email address,
                <br />
                and we will help you to set a new password.
              </p>
   
            </div>
   
   
            {/* EMAIL */}
            <div className="login-field">
   
              <label>
                Email
              </label>
   
              <div className="input-wrapper">
   
                <i className="fa-regular fa-envelope input-icon"></i>
   
                <input
                  type="email"
                  className="login-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
   
              </div>
   
            </div>
   
   
            {/* BUTTON */}
            <div className="login-button-container">
   
              <button
                type="submit"
                className="admin-login-btn"
              >
   
                <i className="fa-regular fa-paper-plane"></i>
   
                Send Reset Link
   
              </button>
   
            </div>
   
   
            {/* BACK TO SIGN IN */}
            <div className="back-signin">
   
              <a href="/AdminLogin">
   
                <i className="fa-solid fa-arrow-left" style={{fontWeight:"700"}}></i>
   
               <label style={{fontWeight:"700"}}>Back To Sign In</label>
   
              </a>
   
            </div>
   
          </div>
   
        </form>
   
      </div>
   
    </div>
  );
}

export default ForgetPassword